@import (reference) '../../../constants/spacing.module.less';

.section-visibility-selector-wrapper {
  min-width: 180px;
}

.dropdown-toggler {
  border-radius: 4px;
}
